const locale = require('./submissionDetailsDrawer.i18n.json');

/*@ngInject*/
const SubmissionDetailsDrawerDirective = function ($rootScope, $timeout, $document, $filter, $state, $window, coreMediator, submissionMediator, dateUtil, gridColumnModel,
                                                   submissionGridConstant, currencyUtil, appTypeConfigurationModel, preferenceModel, submissionUtil, coreConstant) {

    let linkFunction = function ($scope, $elm, $attrs) {

        let element = $($elm),
            timerDelay = 300,
            timeoutList = [];

        $scope.i18n = locale;

        $scope.shortDateFormat = coreMediator.getPreferenceByName('view.shortDateFormat');
        $scope.itemModel.drawerOpen = false;

        $scope.underwriterImage = null;
        $scope.assignedToImage = null;
        $scope.referredToImage = null;
        $scope.producerImage = null;
        $scope.contactImage = null;

        $scope.underwriterImageLoading = false;
        $scope.assignedToImageLoading = false;
        $scope.referredToImageLoading = false;
        $scope.producerImageLoading = false;
        $scope.contactImageLoading = false;
        $scope.transactionRecords = [];


        function loadUnderwriterImage() {
            if (!$scope.itemModel.responsibleUnderwriterSummary) {
                return;
            }
            $scope.underwriterImageLoading = true;
            coreMediator.loadProfileImage($scope.itemModel.responsibleUnderwriterSummary.id).then(function (underwriterImage) {
                $scope.underwriterImage = underwriterImage;
                $scope.underwriterImageLoading = false;
            });
        }

        function loadAssignedToImage() {
            if (!$scope.itemModel.assignedUnderwriterSummary) {
                return;
            }
            $scope.assignedToImageLoading = true;
            coreMediator.loadProfileImage($scope.itemModel.assignedUnderwriterSummary.id).then(function (assignedToImage) {
                $scope.assignedToImage = assignedToImage;
                $scope.assignedToImageLoading = false;
            });
        }

        function loadReferredToImage() {
            if (!$scope.itemModel.referredUnderwriterSummary) {
                return;
            }
            $scope.referredToImageLoading = true;
            coreMediator.loadProfileImage($scope.itemModel.referredUnderwriterSummary.id).then(function (referredToImage) {
                $scope.referredToImage = referredToImage;
                $scope.referredToImageLoading = false;
            });
        }

        function loadProducerImage() {
            if (!$scope.itemModel.agentSummary) {
                return;
            }
            $scope.producerImageLoading = true;
            coreMediator.loadProfileImage($scope.itemModel.agentSummary.id).then(function (producerImage) {
                $scope.producerImage = producerImage;
                $scope.producerImageLoading = false;
            });
        }

        function loadContactImage() {
            if (!$scope.itemModel.agencyContactSummary) {
                return;
            }
            $scope.contactImageLoading = true;
            coreMediator.loadProfileImage($scope.itemModel.agencyContactSummary.id).then(function (contactImage) {
                $scope.contactImage = contactImage;
                $scope.contactImageLoading = false;
            });
        }

        function displayTransactionGrid() {
            if(!appTypeConfigurationModel.isAgentConsole()) {
                submissionMediator.getSubmissionTransactions($scope.itemModel.id).then(function (records) {
                    $scope.transactionRecords = records;
                });
            }
        }

        function scrollDrawerIntoView() {
            let $scrollContainer = element.parents('.scrollVerticalContainer'),
                scrollContainerHeight = $scrollContainer.prop('offsetHeight'),
                scrollContainerPosition = $scrollContainer.prop('scrollTop'),
                currentRowPosition = element.parent().position().top,
                currentRowHeight = 60,
                drawerHeight = 0,
                drawerBottomPosition = 0,
                scrollToValue = 0;

            timeoutList.push($timeout(() => {
                drawerHeight = element.prop('offsetHeight');
                drawerBottomPosition = currentRowPosition + currentRowHeight + drawerHeight;

                drawerColumnsEmpty();

                if (drawerBottomPosition > scrollContainerHeight) {
                    scrollToValue = scrollContainerPosition - (scrollContainerHeight - drawerBottomPosition);

                    $scrollContainer.animate({
                        scrollTop: scrollToValue
                    }, 200);
                }
            }, timerDelay));
        }

        function drawerColumnsEmpty() {
            element.find('.drawerCol').each((index, item) => {
                let $drawerColumn = $(item);
                if ($drawerColumn.children().length > 1) {
                    $drawerColumn.css('visibility', 'visible');
                    $drawerColumn.show();
                } else {
                    $drawerColumn.hide();
                }
            });
        }

        $scope.getCreatedBy = () => {
            return $scope.itemModel.createdBy.name === 'AUTHENTICATION_SERVER' ? 'System' : $scope.itemModel.createdBy.name;
        };

        $scope.$on(submissionGridConstant.event.OPEN_SUBMISSION_DETAIL_DRAWER, () => {
            if ($scope.itemModel.selected) {
                $scope.itemModel.totalPremium.currencyFormat = currencyUtil.getCurrencyFormat($scope.itemModel.totalPremium.currencyCode);
                loadProducerImage();
                loadContactImage();
                loadUnderwriterImage();
                loadAssignedToImage();
                loadReferredToImage();
                displayTransactionGrid();
                $scope.itemModel.drawerOpen = true;
                scrollDrawerIntoView();
            }
        });

        $scope.$on(submissionGridConstant.event.CLOSE_SUBMISSION_DETAIL_DRAWER, () => {
            if ($scope.itemModel.drawerOpen) {
                timeoutList.push($timeout(function () {
                    $scope.itemModel.drawerOpen = false;
                }, timerDelay));
            }
        });

        $scope.$on('$destroy', () => {
            _.each(timeoutList, function (item) {
                $timeout.cancel(item);
            });
        });

        $scope.openTransactionItem = function (item, column) {
            submissionMediator.isUserAuthorizedForSubmissionProduct($scope.itemModel.id).then(() => {
                if(column._navigation === 'true'){
                $scope.mouseLeave();
                if (preferenceModel.get('system.submissionHomePageTransactionLinkExternal') === 'true') {
                    $window.open(submissionUtil.getSubmissionTransactionExternalLink(item.uri), '_blank');
                } else {
                    if (item.uri.indexOf('Quote') !== -1) {
                        let quoteId = parseInt(item.uri.split('Quote:')[1]);
                        $state.go('submission.quote', {
                            submissionId: $scope.itemModel.id,
                            quoteId: quoteId
                        });
                        return;
                    } else if (item.uri.indexOf('Policy') !== -1) {
                        let policyId = parseInt(item.uri.split('Policy:')[1]);
                        $state.go('submission.policy', {
                            submissionId: $scope.itemModel.id,
                            policyId: policyId
                        });
                        return;
                    }
                }
            }
        })
        };

        $scope.getTransactionClassName = function (item) {
            let className = item.uri.indexOf('Quote') !== -1 ? 'quote' : 'policy';
            return className + _.toLower(item.columns.product);
        };

        $scope.getValue = function (item, column) {
            let props = [],
                value;
            props.push(column._accessor);
            value = item;
            for (let i = 0; i < props.length; i++) {
                if (!_.isNil(value)) {
                    value = value.columns[props[i]];
                }
            }

            if(_.isUndefined(value)) {
                value = '-';
            }

            if (column._type && !_.isNil(value) && (column._type.indexOf('shortDate') >= 0 || column._type.indexOf('utcShortDate') >= 0)) {
                const filter = $filter('utcDateFilter');
                value = filter(parseInt(value), $scope.shortDateFormat);
            } else if (column._type && column._type.indexOf('currency') >= 0) {
                const filter = $filter('currency');
                let currencyFormat = currencyUtil.getCurrencyFormat(value.currencyCode);
                if(parseInt(value.total) > 0) {
                    value = filter(parseInt(value.total), currencyFormat.symbol, 0, currencyFormat.suffixSymbol, currencyFormat.customFormat);
                } else {
                    value = '-';
                }
            }
            return value;
        };

        $scope.mouseEnter = function (event, item) {
            $scope.isMouseEnterInProgress = true;
            $scope.mouseEnterTimer = $timeout(function () {
                if ($scope.isMouseEnterInProgress) {
                    event.columns = item.columns;
                    event.uri = item.uri;
                    $scope.showTooltip(event);
                }
                $scope.isMouseEnterInProgress = false;
            }, 500);
        };

        $scope.mouseLeave = function () {
            $timeout.cancel($scope.mouseEnterTimer);
            $scope.isMouseEnterInProgress = false;
            $timeout.cancel($scope.mouseLeaveTimer);
            $scope.mouseLeaveTimer = $timeout(function () {
                $rootScope.$broadcast(coreConstant.event.HIDE_TRANSACTION_TOOLTIP_EVENT);
            }, 250);
        };

        $scope.showTooltip = function (event) {
            $rootScope.$broadcast(coreConstant.event.SHOW_TRANSACTION_TOOLTIP_EVENT, event);
        };

        if(!appTypeConfigurationModel.isAgentConsole()) {
            gridColumnModel.setColumnPreference('system.submissionTransactionsHomePageGridColumns');
            $scope.colViewModel = gridColumnModel.getSubmissionTransactionGridColumns();
        }
    };

    return {
        restrict: 'E',
        replace: true,
        scope: {
            itemModel: '<?',
            colViewModel: '<?',
            isAgent: '<?'
        },
        link: linkFunction,
        templateUrl: '/submissionDetailsDrawer/submissionDetailsDrawerDirective.tpl.html'
    };
};

angular.module('gw-um-submission-grid')
    .directive('submissionDetailsDrawerDirective', SubmissionDetailsDrawerDirective);
